import { createConsola } from "consola";

export function useAppLogger(tag: string = "dealer-portal") {
  const instance = getCurrentInstance();
  if (!tag && instance) {
    const name = instance.type.name || instance.type.__name;
    if (name) tag = name;
  }

  const logger = createConsola().withDefaults({ tag });
  return logger;
}
